// extracted by mini-css-extract-plugin
module.exports = {"item":"DocumentItem_item__1jdlB","button":"DocumentItem_button__35N5Z","icon":"DocumentItem_icon__f-z3O"};